import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import {Iterable} from 'immutable';
import {remove, isEmpty, map} from 'lodash';
import makeRef from 'lib/makeRef';
import tablesort from 'tablesort';
import './sortable-table.scss';

if (process.env.IS_BROWSER) {
  /**
   * tablesort extensions modify the Tablesort object, so we need to attach it to the global
   * scope directly. Since sorting doesn't happen on the server, we only need to do this on the client.
   */
  global.Tablesort = tablesort;
  import('tablesort/src/sorts/tablesort.number');
  import('tablesort/src/sorts/tablesort.date');
  import('tablesort/src/sorts/tablesort.monthname');
}

marked.setOptions({
  breaks: true,
  gfm: true,
  tables: true
});

function getCellCount(content) {
  let lines;
  if (content.includes('\r\n')) {
    lines = content.split(/\r\n/g);
  } else {
    lines = content.split(/\n/g);
  }

  const firstLine = lines[0];
  const splitLine = firstLine.split('|');
  if (splitLine) {
    return remove(splitLine, (entry) => {
      return !isEmpty(entry);
    });
  }
  return null;
}

export default class SortableTable extends React.Component {
  static propTypes = {
    content: PropTypes.object
  };

  static defaultProps = {
    content: {
      text: ''
    }
  };

  componentDidMount() {
    this.init();
  }

  componentDidUpdate() {
    if (!this.sort) {
      this.init();
    } else {
      this.sort.refresh();
    }
  }

  wrapperNode = null;

  makeRef = makeRef.bind(this);

  init() {
    const table = this.wrapperNode.firstElementChild;
    if (!table.nodeName || table.nodeName !== 'TABLE') {
      return;
    }
    this.sort = tablesort(table);
  }

  render() {
    const content = Iterable.isIterable(this.props.content)
      ? this.props.content.toJS()
      : this.props.content;
    let text = content.text;
    if (text) {
      const cells = getCellCount(text);
      if (this.props.hasTotal && cells && cells.length > 0) {
        const footerCells = map(cells, () => {
          return '<th></th>';
        });
        text = marked(text).replace(
          '</tbody>',
          `<tfoot><tr>${footerCells.join('')}</tr></tfoot></tbody>`
        );
      } else {
        text = marked(text);
      }
    } else {
      text = 'No content entered.';
    }
    return (
      <div
        className='sortable-table'
        ref={this.makeRef}
        data-ref-name='wrapperNode'
        dangerouslySetInnerHTML={{__html: text}}
      />
    );
  }
}
